import $ from 'jquery'
import 'jquery.mmenu/dist/jquery.mmenu'
import 'jquery.mmenu/dist/addons/setselected/jquery.mmenu.setselected'

/*************** Mobile Menu ***************/
const mobile_menu = $('#mobile_menu_main_container').mmenu({
	setSelected: {
		// set selected options
		current: 'detect',
	},
	offCanvas: {
		position: 'right',
	},
	counters: true,
	slidingSubmenus: true,
	navbars: [
		{
			position: 'top',
		},
	],
	extensions: ['position-front', 'position-bottom', 'pagedim-black'],
})
const mobile_toggle = $('#toggle-menu') //what opens menu

// mobile_menu

const API = mobile_menu.data('mmenu')

mobile_toggle.click(function (event) {
	event.preventDefault()
	API.open()
})

/**
 * Create a close button element and append it
 * to the inside of the mobile menu region.
 */
$('.mm-navbar').append('<a href="#" class="close-menu-mm">Close Menu</a>')

$('.mm-navbar').on('click', '.close-menu-mm', function (event) {
	// console.log(event)
	event.preventDefault()
	API.close()
})

/*************** Search ***************/
$('#mobile_menu_search_container').mmenu({
	setSelected: {
		// set selected options
		current: 'detect',
	},
	offCanvas: {
		position: 'right',
	},
	navbars: [
		{
			position: 'top',
		},
	],
	extensions: ['position-front', 'position-bottom', 'pagedim-black'],
})
var API2 = $('#mobile_menu_search_container').data('mmenu')

$('#toggle-search').click(function () {
	API2.open()
})

/**
 * Create a close button element and append it
 * to the inside of the mobile menu region.
 */
$('.mobile-search .mm-navbar').append('<a href="#" class="close-menu-mm" id="close_menu_mm_search">Close Search</a>')

$('#close_menu_mm_search').click(function (event) {
	event.preventDefault()
	API2.close()
})

/*************** Login ***************/
$('#mobile_menu_login_container').mmenu({
	setSelected: {
		// set selected options
		current: 'detect',
	},
	offCanvas: {
		position: 'right',
	},
	navbars: [
		{
			position: 'top',
		},
	],
	extensions: ['position-front', 'position-bottom', 'pagedim-black'],
})
var API3 = $('#mobile_menu_login_container').data('mmenu')

$('#toggle-login').click(function () {
	API3.open()

	$('#uid').focus()
})

/**
 * Create a close button element and append it
 * to the inside of the mobile menu region.
 */
$('.mobile-login .mm-navbar').append('<a href="#" class="close-menu-mm" id="close_menu_mm_login">Close Login</a>')

$('#close_menu_mm_login').click(function (event) {
	event.preventDefault()
	API3.close()
})
